webpackJsonp([80304597903929],{

/***/ 1503:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PaymentInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"method","type":{"kind":"ENUM","name":"PaymentMethod","ofType":null}},{"defaultValue":null,"description":null,"name":"methodType","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"notes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"reference","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-payment-input-4ed81ab949fbb40c8515.js